import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ClerkProvider } from '@clerk/react';
import { ThemeProvider } from './components/ThemeProvider';
import { ToastProvider } from './components/ToastProvider';
import { getRouter } from './router';
import './styles.css';

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

function OptionalClerkProvider({ children }: { children: React.ReactNode }) {
  if (!clerkPublishableKey) return <>{children}</>;
  return <ClerkProvider publishableKey={clerkPublishableKey}>{children}</ClerkProvider>;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <OptionalClerkProvider>
      <ThemeProvider>
        <ToastProvider>
          <RouterProvider router={getRouter()} />
        </ToastProvider>
      </ThemeProvider>
    </OptionalClerkProvider>
  </StrictMode>,
);
